module.exports = __webpack_public_path__ + "static/media/flask-potion.4ec1adb2.svg";